import { Modal } from "react-bootstrap";
import { useState } from "react";
import MTLOGOTire from "../../img/Logo_spinner.png"

function PaymentLinkModal(props) {
  const { show, onHide, link, useFor } = props;

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(link).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <>
      <Modal show={show} centered onHide={onHide} backdrop="static" size="md">
        <Modal.Header closeButton>
          <div
            className="d-flex align-items-center"
            style={{
              backgroundColor: "white",
              borderTopLeftRadius: "6px",
              borderTopRightRadius: "6px",
            }}
          >
            <img src={MTLOGOTire} height={36} />
            <div className="ms-3">
              <h6
                className="h5 text-left fw-semibold mb-0"
                style={{ color: "black" }}
              >
               {useFor==="backout" ? "User Backout Payment URL" : "User Added Successfully"}
              </h6>
              <p className="text-left text-md mb-0" style={{ color: "black" }}>
                You can copy & share payment URL
              </p>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className="col-12 border p-2 d-flex flex-row justify-content-between"
            style={{ borderRadius: "4px" }}
          >
            <p
              className="m-0 text-md d-flex"
              style={{
                overflow: "hidden",
              }}
              onClick={() => {
                handleCopy();
              }}
            >{link}
            </p>

            {copied ? (
              <p className="align-content-center mb-0" style={{ color: "green", fontSize:'14px', }}>Copied!</p>
            ) : (
              <i
                className="bi bi-copy ms-3 me-2 align-content-center"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  handleCopy();
                }}
              ></i>
            )}
          </div>

          {/* <div style={{ justifyItems: "end" }}>
            <div
              className="px-4 py-1"
              style={{
                backgroundColor: "#ed1c24",
                color: "white",
                width: "fit-content",
                borderRadius: "6px",
                cursor: "pointer",
              }}
              onClick={() => {
                onHide();
              }}
            >
              Close
            </div>
          </div> */}
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PaymentLinkModal;
